import React from "react";
import { useFormContext } from "react-hook-form";
import { Box, Typography, Grid } from "@mui/material";
import { Irai } from "../types/GxpTypes";
import { useData } from "../utils/DataContext";
import { RenderColumn } from "../utils/IraiDisplayUtils";
import { getDisplayEntriesForReview, splitEntriesForColumns } from "../utils/DisplayUtils";

const IraiReview = () => {
  const { getValues } = useFormContext<Irai>();
  const { getMaster } = useData();
  const values = getValues();

  const displayEntries = getDisplayEntriesForReview(values);
  const [leftColumnEntries, rightColumnEntries] = splitEntriesForColumns(displayEntries);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        (5/5) 確認
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <RenderColumn entries={leftColumnEntries} getMaster={getMaster} />
        </Grid>
        <Grid item xs={6}>
          <RenderColumn entries={rightColumnEntries} getMaster={getMaster} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IraiReview;
